import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

/* PASO 3 (F3B) — UIContext: toast global + clipboard. Mismo comportamiento
 * (4.5s auto-dismiss, mismos textos). */
const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((title, description, type = "success") => {
    setToast({ title, description, type });
    setTimeout(() => setToast(null), 4500);
  }, []);

  const copyToClipboard = useCallback(async (text, label = "Copiado") => {
    try {
      await navigator.clipboard.writeText(text);
      showToast(label, text.length > 40 ? text.slice(0, 40) + "..." : text, "success");
    } catch {
      showToast("Error", "No se pudo copiar", "error");
    }
  }, [showToast]);

  const value = useMemo(() => ({ toast, showToast, copyToClipboard }),
    [toast, showToast, copyToClipboard]);

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (ctx == null) throw new Error("useUI must be used inside <UIProvider>");
  return ctx;
}
